/**
 * DEFAULT_SEARCH_CONFIG — the user-agnostic search-targeting seed (W2).
 *
 * A generic German-market starting point: the trusted-source allowlist, a result
 * budget, and a quality floor are pre-filled, while the TARGETING lists start
 * EMPTY (those are what W2 elicits and the user authors). NOT Markus-specific.
 *
 * NOTE the re-derivation: `minTier` uses the unified `MatchTier` vocabulary
 * (`strong | viable | weak | unsuited`); the sensible generic floor is `viable`
 * (the quarry's `moderate` value no longer exists).
 */

import type { SearchConfig } from "./inferred"

/** Major German job boards + common ATS hosts (the trusted-source floor). */
const GERMAN_MARKET_SOURCES = [
  "stepstone.de",
  "linkedin.com",
  "indeed.com",
  "xing.com",
  "arbeitnow.com",
  // common ATS hosts postings syndicate through
  "join.com",
  "personio.de",
  "greenhouse.io",
  "lever.co",
  "workday.com",
] as const

/**
 * The generic seed. `satisfies SearchConfig` keeps it in lock-step with the
 * shared primitive shape (a new required field is a compile error) while
 * preserving the literal types for the frozen export.
 */
export const DEFAULT_SEARCH_CONFIG = {
  roles: [],
  queries: [],
  seniority: [],
  locations: [],
  excludeKeywords: [],
  summary: "",
  sourceAllowlist: [...GERMAN_MARKET_SOURCES],
  allowCompanyWebsites: true,
  minTier: "viable",
  limit: 40,
} satisfies SearchConfig
